<script setup>
import SpinningCoin from '@components/global/loading/SpinningCoin.vue'
</script>

<template>
	<div class="pointer-events-none flex h-[calc(100dvh+2.5rem)] w-full touch-none select-none items-center justify-center bg-crowns-off-black bg-modal-pattern bg-size-60 bg-right-top bg-no-repeat sm:bg-auto">
		<SpinningCoin />
	</div>
</template>
